import React from "react";
import { useLanguage } from "../context/LanguageContext";
import Seo, { ORG_JSONLD } from "../components/Seo";
import Hero from "../components/home/Hero";
import Partners from "../components/home/Partners";
import Methodology from "../components/home/Methodology";
import ServicesOverview from "../components/home/ServicesOverview";
import Results from "../components/home/Results";
import FeaturedSolutions from "../components/home/FeaturedSolutions";
import Process from "../components/home/Process";
import References from "../components/home/References";
import FAQ from "../components/home/FAQ";
import CTABanner from "../components/home/CTABanner";
import { translations } from "../i18n/translations";

const Home = () => {
  const { lang } = useLanguage();

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: translations[lang].faq.items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  const desc =
    lang === "tr"
      ? "İstanbul merkezli butik IT ajansı. IT altyapı analizi, siber güvenlik, Power BI iş zekası, bulut ve Universal Print ile dijital dönüşüm. Ücretsiz IT röntgeni."
      : "Istanbul-based boutique IT agency. Digital transformation with IT infrastructure analysis, cyber security, Power BI, cloud and Universal Print. Free IT assessment.";

  return (
    <>
      <Seo
        title={
          lang === "tr"
            ? "Kurumsal IT Çözümleri & Dijital Dönüşüm Ajansı"
            : "Enterprise IT Solutions & Digital Transformation Agency"
        }
        description={desc}
        path="/"
        lang={lang}
        jsonLd={[ORG_JSONLD, faqJsonLd]}
      />
      <Hero />
      <Partners />
      <Methodology />
      <ServicesOverview />
      <Results />
      <FeaturedSolutions />
      <References />
      <Process />
      <FAQ />
      <CTABanner />
    </>
  );
};

export default Home;
